<template>
  <div class="baColor">
    <div class="damandList">
      <div class="damandList_box w1200Auto">
        <div class="flex-item-center breadcrumb">
          <span style="font-size: 14px; padding-left: 5px">当前位置：</span>
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/supplyHome' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item style="cursor: pointer" :to="{ name: 'supplyHome' }"
              >供需对接</el-breadcrumb-item
            >
            <el-breadcrumb-item style="color: #009999"
              >需求列表</el-breadcrumb-item
            >
          </el-breadcrumb>
        </div>
        <div class="flex">
          <div class="searchContainer">
            <!-- 分类 -->
            <div class="print_screen_box flex" style="position: relative">
              <div style="width: 100%; color: #6e6e6e">
                <!-- 需求类型： -->
                <div style="display: flex; margin-top: 15px">
                  <p class="print_title">需求类型：</p>
                  <div class="print_screen_boxP">
                    <p
                        v-for="(items, index) in firstList"
                        :key="index"
                        @click="changeScreen(index, items)"
                        :class="printScreenIndex == index ? 'screen_text' : ''"
                    >
                      {{ items.name }}
                    </p>
                  </div>
                </div>
                <!-- 需求一级分类： -->
                <div style="display: flex">
                  <p class="print_title">需求分类：</p>
                  <div class="print_screen_boxP" style="margin-bottom: 6px">
                    <p
                      v-for="(items, index) in firstClassList"
                      :key="index"
                      :class="printScreenTwoIndex == index ? 'screen_text' : ''"
                      @click="changeScreenTwo(index, items)"
                      style="cursor: pointer"
                    >
                      {{ items.cdLabel }}
                    </p>
                  </div>
                </div>
                <!-- 二级分类 -->
                <div
                  class="flex"
                  style="
                    padding: 15px 15px 5px;
                    background: #f5f7fa;
                    color: #6e6e6e;
                    margin-left: 93px;
                    display: flex;
                    flex-wrap: wrap;
                  "
                  v-show="classShow"
                >
                  <p
                    v-for="(items, index) in secondClassList"
                    :key="index"
                    :class="
                      printScreenThreeIndex == index ? 'materDetailsT' : ''
                    "
                    @click="changeScreenThree(index, items)"
                    style="cursor: pointer"
                  >
                    {{ items.cdLabel }}
                  </p>
                </div>
              </div>
            </div>
            <!-- 搜索 -->
            <div class="flex searchContainerone">
              <p class="print_title">关键词：</p>
              <el-input
                placeholder="请输入关键词"
                v-model="demandName"
                class="input-with-select"
                clearable
                prefix-icon="el-icon-search"
              >
              </el-input>
              <el-button type="primary" @click="search"> 搜索 </el-button>
            </div>

            <!-- 图片 -->
            <div class="demand_imgMesg">
              <div
                class="imgMesg_box"
                v-for="(item, index) in imgMesgList"
                :key="index"
              >
                <h3>{{ item.name }}</h3>
                <p>{{ item.mesg1 }}</p>
                <p>{{ item.mesg2 }}</p>
                <img :src="item.imgs" alt="" />
              </div>
            </div>
          </div>
          <div class="demand_push">
            <h2>发布生产、经营需求让专业服务商来找您</h2>
            <el-button icon="el-icon-s-order" @click="openDemand"
              >发布需求</el-button
            >
            <div class="push_mesg flex-item-center">
              <div class="push_mesg_box">
                <p class="push_mesg_box_num">{{ todayNewDemands }}<span>条</span></p>
                <p>今日新增需求</p>
              </div>
              <i></i>
              <div class="push_mesg_box">
                <p class="push_mesg_box_num">{{ totalProviders }}<span>家</span></p>
                <p>优质服务商</p>
              </div>
            </div>
          </div>

          <div></div>
        </div>
        <div class="flex-item-center demande_news">
          <p class="demande_title">排序：</p>
          <div
            class="demande_shai"
            v-for="(item, index) in sortList"
            :key="index"
            @click="onClickSort(item)"
          >
            <span class="shai_name" :class="item.className">{{
              item.name
            }}</span>
            <div class="demande_shai_i">
              <i
                class="el-icon-caret-top"
                :class="item.iconsColorShow ? item.className : ''"
              ></i>
              <i
                class="el-icon-caret-bottom"
                :class="!item.iconsColorShow ? item.className : ''"
              ></i>
            </div>
          </div>
        </div>
        <!-- 列表 -->
        <div v-if="tableList.length">
          <div class="hotMesg">
            <div
              class="hotMesg_box"
              v-for="(item, index) in tableList"
              :key="index"
              @mouseenter="item.budgerClass = 'budget_active'"
              @mouseleave="item.budgerClass = ''"
            >
              <p class="hotMesg_box_title ellipsis-1">{{ item.demandName }}</p>
              <p
                class="hotMesg_icons"
                :style="{ backgroundImage: `url(${imgs1})` }"
                v-if="
                  item.status != 'DRAFT' &&
                  item.status != 'AUDIT' &&
                  item.status != 'REJECT' &&
                  item.status != 'CANCEL' &&
                  (item.resOfferVos.length == 0)
                "
              >
                进行中
              </p>
              <p
                class="hotMesg_icons"
                :style="{ backgroundImage: `url(${imgs4})` }"
                v-if="
                  item.status != 'DRAFT' &&
                  item.status != 'AUDIT' &&
                  item.status != 'REJECT' &&
                  item.status != 'CANCEL' &&
                  (item.resOfferVos.length != 0)
                "
              >
                洽谈中
              </p>
              <p
                class="hotMesg_icons"
                :style="{ backgroundImage: `url(${imgs2})` }"
                v-if="
                  item.status != 'DRAFT' &&
                  item.status != 'AUDIT' &&
                  item.status != 'REJECT' &&
                  item.status != 'CANCEL' &&
                  item.status != 'UN_OFFERD'
                "
              >
                已对接
              </p>
              <p
                class="hotMesg_icons"
                :style="{ backgroundImage: `url(${imgs3})` }"
                v-if="item.status == 'END'"
              >
                已截止
              </p>
              <p
                class="hotMesg_icons2"
                :style="{ backgroundImage: `url(${imgs3})` }"
                v-if="item.status == 'CANCEL'"
              >
                已取消
              </p>
              <div class="hotMesg_box_content ellipsis-1">
                <p class="text_line">
                  <span>需求方：</span>
                  <span class="text_nowarp">{{ item.buyer }}</span>
                </p>
                <p>
                  <span>类型：</span>
                  <span>{{ item.demandTypeCn }}</span>
                </p>
              </div>
              <div class="hotMesg_box_bot">
                <div class="hotMesg_box_botMesg">
                  <p class="hotMesg_box_botMesgP">发布时间</p>
                  <p>
                    {{
                      item.publishTime
                        ? moment(item.publishTime).format("YYYY-MM-DD")
                        : ""
                    }}
                  </p>
                </div>
                <div class="hotMesg_box_botMesg" v-if="item.secondBidding == 1">
                  <p class="hotMesg_box_botMesgP">截止时间</p>
                  <p>{{ item.deadlineSecond }}</p>
                </div>
                <div class="hotMesg_box_botMesg" v-else>
                  <p class="hotMesg_box_botMesgP">截止时间</p>
                  <p>{{ item.deadline }}</p>
                </div>
              </div>
              <div class="budget" :class="item.budgerClass">
                <div class="budget_mbox">
                  <p>预算金额：</p>
                  <h2 class="budget_m" v-if="item.budgetType == 0">
                    {{ item.budgetPrice }}
                  </h2>
                  <h2 class="budget_m" v-else-if="item.budgetType == 1">
                    {{ item.budgetMin + "-" + item.budgetMax }}
                  </h2>
                  <h2 class="budget_m" v-else>无预算</h2>
                </div>
                <p class="budget_btn" @click="gotoBudget(item.id)">
                  {{ item.status == "UN_OFFERD" ? "去报价" : "查详情" }}
                </p>
              </div>
            </div>
          </div>
          <div style="text-align: center; width: 100%">
            <el-pagination
              style="margin-right: -10px"
              @current-change="handleCurrentChange"
              @prev-click="handleCurrentChange"
              @next-click="handleCurrentChange"
              layout="total,prev, pager, next,jumper"
              :current-page="currentPage"
              :page-size="pageSize"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
        <el-empty description="暂无数据" v-else :image-size="100"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import {
  findFirstClasses,
  findTypeByParentClass,
  getDemandsByPage,
  getTotalProviders,
} from "../../../../utils/interface";
export default {
  data() {
    return {
      demandType: "",
      classifyOneUuid: "",
      classifyTwoUuid: "",
      demandName: "",
      options: "",
      sort: "",
      printScreenIndex: "0",
      firstList: [
        {
          name: "全部",
        },
        {
          id: "SERVICE",
          name: "服务需求",
        },
        {
          id: "PRODUCT",
          name: "产品需求",
        },
      ],
      printScreenTwoIndex: "0",
      firstClassList: [
        {
          cdLabel: "全部",
        },
      ],
      printScreenThreeIndex: "0",
      secondClassList: [],
      classShow: false,
      imgMesgList: [
        {
          name: "行业优质供应商",
          mesg1: "水泵行业供应商资源",
          mesg2: "采购无忧",
          imgs: require("@/assets/supplyHome/page1.jpg"),
        },
        {
          name: "为您匹配",
          mesg1: "为您匹配",
          mesg2: "推荐优质供应商",
          imgs: require("@/assets/supplyHome/page2.jpg"),
        },
        {
          name: "提供效率",
          mesg1: "节省时间",
          mesg2: "提升采购效率",
          imgs: require("@/assets/supplyHome/page3.jpg"),
        },
      ],
      sortList: [
        {
          name: "发布时间",
          className: "",
          iconsColorShow: "",
        },
        {
          name: "截止时间",
          className: "",
          iconsColorShow: "",
        },
      ],
      currentPage: 1,
      pageSize: 12,
      total: 0,
      imgs1: require("../../../../assets/supplyHome/green.jpg"),
      imgs2: require("../../../../assets/supplyHome/yellow.jpg"),
      imgs3: require("../../../../assets/supplyHome/gray.jpg"),
      imgs4: require("../../../../assets/supplyHome/blue.jpg"),
      tableList: [],
      totalProviders: 0,
      todayNewDemands: 0,
    };
  },
  created() {
    getTotalProviders().then((res) => {
      this.totalProviders = Number(res.data.totalProviders);
      this.todayNewDemands = Number(res.data.todayNewDemands);
    });
    this.getFirstClass();
    this.search();
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
       document.documentElement.scrollTop = 400;
      document.body.scrollTop = 400;
    },
    gotoDetails(uuid) {
      let routeData = this.$router.resolve({
        path: `/demandDetails?uuid=${uuid}`,
      });
      window.open(routeData.href, "_blank");
    },
    gotoBudget(uuid) {
      let routeData = this.$router.resolve({
        path: `/demandDetails?uuid=${uuid}`,
      });
      window.open(routeData.href, "_blank");
    },
    changeScreen(index, item) {
      this.printScreenIndex = index;
      this.demandType = item.id;
      this.search();
    },
    changeScreenTwo(index, item) {
      this.printScreenTwoIndex = index;
      if(index != 0){
        this.classifyOneUuid = item.cdClass;
        findTypeByParentClass({ cdClass: item.cdClass }).then((res) => {
          if (res) {
            this.secondClassList = [];
            this.secondClassList.push({cdLabel: "全部"});
            res.data.forEach((item) => {
              this.secondClassList.push(item);
            });
          }
        });
        this.search();
        this.classShow = true;
      } else{
        this.classifyOneUuid = "";
        this.classifyTwoUuid = "";
        this.secondClassList = [];
        this.search();
        this.classShow = false;
      }

    },
    changeScreenThree(index, item) {
      this.classifyTwoUuid = item.cdClass;
      this.printScreenThreeIndex = index;
      this.search();
    },
    onClickSort(item) {
      this.sortList.forEach((item) => {
        item.className = "";
      });
      item.iconsColorShow = !item.iconsColorShow;
      item.className = "shai_name_active";
      if (item.iconsColorShow) {
        this.sort = "ASC";
      } else {
        this.sort = "DESC";
      }
      if (item.name == "发布时间") {
        this.options = 2;
      } else if (item.name == "截止时间") {
        this.options = 3;
      }
      this.search();
    },
    openDemand() {
      let routeData = this.$url.buyerWeb + `#/publishDemand`;
      if (routeData != "") {
        window.open(routeData, "_blank");
      }
    },
    search() {
      let params = {
        demandName: this.demandName,
        demandType: this.demandType,
        classifyOneUuid: this.classifyOneUuid,
        classifyTwoUuid: this.classifyTwoUuid,
        options: this.options,
        sort: this.sort,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      };
      getDemandsByPage(params).then((res) => {
        this.currentPage = Number(res.data.current);
        this.total = Number(res.data.total);
        this.tableList = res.data.records;
      });
    },
    getFirstClass() {
      findFirstClasses().then((res) => {
        if (res) {
          res.data.forEach((item) => {
            this.firstClassList.push(item);
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../style/index.less";
.damandList {
  background: url("../../../../assets/supplyHome/demandBanner.jpg") no-repeat;
  background-size: 100% 40%;
}
.damandList_box {
  padding: 20px;
  // .breadcrumb {
  //   color: #fff;
  // }
  // /deep/.el-breadcrumb {
  //   span {
  //     color: #fff;
  //   }
  // }
}
.text_line{
  width: 100%;
  position: relative;
  display: flex;
  .text_nowarp{
  width: calc(100% - 60px) !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
}
.searchContainer {
  background: #fff;
  padding: 20px 30px;
  padding-top: 26px;
  width: 100%;
  .searchContainerone {
    margin-top: 15px;
    display: flex;
    align-items: center;
    .searchContainerButton {
      color: #009999;
      margin-left: 60px;
      border: 1px solid #009999;
      background: #fff;
      font-size: 14px;
    }
    button {
      width: 90px;
      border-radius: 8px;
    }
  }
  /deep/.el-input {
    width: 500px;
    margin-right: 10px;
  }
  /deep/ .input-with-select .el-input__inner {
    background: #fdfdfd;
    border: 1px solid #cecece;
    height: 40px;
    border-radius: 8px;
    line-height: 40px;
    width: 500px;
  }

  ul {
    display: flex;
    align-items: center;
    width: 812px;
    padding-left: 3px;
    margin: 0 auto;
    margin-bottom: 15px;
    img {
      width: 20px;
    }
    li {
      font-size: 12px;
      margin-top: 10px;
      padding: 0 15px;

      &.textLi {
        cursor: pointer;

        &:hover {
          color: #009999;
        }
      }
    }
  }
}
.print_title {
  flex-shrink: 0;
  padding-right: 19px;
  padding-left: 0px;
  color: #000;
  font-weight: 500;
  font-size: 14px;
  width: 80px;
  text-align: right;
}
.print_screen_box {
  background: #fff;
  padding: 0 15px 0 0;
  box-sizing: border-box;

  .print_title {
    flex-shrink: 0;
    padding-right: 41px;
    padding-left: 0px;
    color: #000;
    font-weight: 500;
  }

  .print_screen_boxP {
    display: flex;
    flex-wrap: wrap;
    margin-left: -29px;
    p {
      cursor: pointer;
    }

    .screen_text {
      color: #009999;
      border-radius: 5px;
      margin-bottom: 10px;
      padding: 3px 15px;
      font-size: 14px;
      cursor: pointer;
    }
  }

  .screen_text {
    color: #009999;
    cursor: pointer;
    border-radius: 5px;
    margin-bottom: 10px;
    padding: 3px 15px;
    font-size: 14px;
  }

  p {
    margin-bottom: 10px;
    margin-right: 0px;
    padding: 3px 14px;
    font-size: 14px;
  }

  .materDetailsT {
    // background: #009999;
    color: #009999;
    border-radius: 5px;
    padding: 3px 15px;
    margin-bottom: 10px;
  }
}
.print_screen_box:nth-last-child(1) {
  border-top: 1px solid #efefef;
}
.demand_imgMesg {
  display: grid;
  grid-template-columns: 32% 32% 32%;
  grid-column-gap: 16px;
  margin-top: 15px;
  .imgMesg_box {
    background: #ebf3fe;
    padding: 30px 20px 60px;
    position: relative;
    h3 {
      margin-bottom: 20px;
    }
    p {
      color: #333;
    }
    img {
      position: absolute;
      right: 0;
      bottom: 0;
    }
  }
}
.demand_push {
  width: 300px;
  flex-shrink: 0;
  background: url("../../../../assets/supplyHome/megsBanner.jpg") no-repeat;
  color: #fff;
  box-sizing: border-box;
  padding: 30px 20px;
  text-align: center;
  h2 {
    margin-top: 50px;
    margin-bottom: 40px;
    font-size: 26px;
    letter-spacing: 2px;
    line-height: 38px;
  }
  button {
    border: 1px solid #ffff;
    background: #2e85eb;
    width: 180px;
    color: #fff;
    font-size: 18px;
  }
  .push_mesg {
    margin-top: 40px;
    justify-content: center;
    background: #01a7f0;
    border-radius: 10px;
    padding: 20px 0;
    i {
      display: inline-block;
      width: 2px;
      height: 63px;
      margin: 0 16px;
      background: #fff;
    }
    .push_mesg_box {
      .push_mesg_box_num {
        font-size: 28px;
        font-weight: bold;
        margin-bottom: 10px;
        span {
          font-size: 12px;
          margin-left: 5px;
        }
      }
    }
  }
}
.demande_news {
  padding: 20px 30px;
  flex-shrink: 0;
  background: #fff;
  margin-top: 7px;
  font-size: 14px;
  .demande_title {
    margin-right: 30px;
    font-weight: 500;
  }
  .demande_shai {
    margin-right: 30px;
    color: #6e6e6e;
    display: flex;
    align-items: center;
    .demande_shai_i {
      display: flex;
      flex-direction: column;
      margin-left: 6px;
      i {
        display: inline-block;
        height: 10px;
      }
    }
    .shai_name {
      cursor: pointer;
      &:hover {
        color: #009999;
      }
    }
    .shai_name_active {
      color: #009999;
    }
  }
}
.hotMesg {
  display: grid;
  grid-template-columns: 24% 24% 24% 24%;
  grid-gap: 16px;
  margin-top: 10px;
  margin-bottom: 20px;
  .hotMesg_box {
    border-radius: 4px;
    background: #fff;
    position: relative;
    box-shadow: 0px 3px 11px #e9e9e9;
    .hotMesg_icons {
      position: absolute;
      right: -6px;
      top: 35%;
      background-size: 100% 100%;
      padding: 3px 15px;
      font-size: 12px;
      color: #fff;
    }
    .hotMesg_icons2 {
      position: absolute;
      right: -0;
      top: 35%;
      width: 40px;
      height: 50px;
      background-size: 100% 100%;
      padding: 3px 15px;
      font-size: 12px;
      color: #fff;
    }
    .hotMesg_box_title {
      font-size: 16px;
      padding: 12px 20px 10px 14px;
      border-bottom: 1px solid #ededed;
      font-weight: 600;
      color: #333333;
    }
    .hotMesg_box_content {
      font-size: 14px;
      padding: 8px 12px 0;
      line-height: 32px;
      color: #333333;
      .red {
        color: #d9001b;
      }
    }
    .hotMesg_box_bot {
      display: grid;
      grid-template-columns: 50% 50%;
      margin: 20px 6px;
      margin-bottom: 0;
      background: #fafafc;
      padding: 4px 0;

      .hotMesg_box_botMesg {
        font-size: 12px;
        padding: 6px;
        text-align: center;
        display: flex;
        align-items: center;
        color: #333333;
        .hotMesg_box_botMesgP {
          color: #999999;
          font-weight: 400;
          margin-right: 6px;
        }
      }
    }
    .budget {
      border-top: 1px solid #ededed;
      margin-bottom: 8px;
      display: flex;
      margin-top: 16px;
      padding-top: 11px;
      align-items: center;
      .budget_mbox {
        margin: 0 auto;
        font-size: 14px;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        .budget_m {
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #e83636;
          font-size: 14px;
          margin-left: 9px;
        }
      }
      .budget_btn {
        padding: 3px 12px;
        margin: 0 auto;
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        color: #169999;
        background: rgba(22, 153, 153, 0.1);
        border-radius: 36px;
      }
    }
    .budget_active {
      flex-direction: column;
      margin-top: 0;
      .budget_mbox {
        margin-bottom: 0;
      }
      .budget_btn {
        width: 220px;
        text-align: center;
        padding: 3px 12px;
        color: #fff;
        background: #009999;
        margin: 0 auto;
        cursor: pointer;
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/supplyHome/components/list/demandList.vue